/**
 *
 * ResultByDimensionV2
 *
 */

import "./index.less"

import { Button, Checkbox, Popover, Spin, Tooltip } from "antd"
import {
  CaretDownOutlined,
  CaretUpOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons"
import React, { Fragment } from "react"
import { find, get, isEqual, truncate } from "lodash"
import { markReadActionPlan, markReadComment } from "../DrawerActionPlan/api"

import Bubbles from "../Bubbles"
import FlechaSVG from "../../images/iconoFlecha.svg"
import MeasurementColorRange from "../MeasurementColorRange"
import ProgressBar from "../ProgressBar"
import imgCommentTable from "../../images/comment-table.svg"
import imgEllipses from "../../images/ellipses.svg"
import imgMark from "../../images/mark_item.svg"
import imgWarning from "../../images/warning.svg"
import questionIcon from "images/question.svg"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { isModuleBySlug } from "../../utils/storage"
import { ACTION_PLANS } from "../../utils/constants"

// import PropTypes from 'prop-types';

/* eslint-disable react/prefer-stateless-function */
class ResultByDimensionV2 extends React.Component {
  state = {
    modalActionPlanCreate: false,
    drawerActionPlan: false,
    drawerActionPlanOpenIn: "1",
    dimensionSelected: undefined,
    paintRowIndex: undefined,
    columns: [
      {
        name: "Dimensiones",
        order: {
          active: false,
          type: "asc",
          key: "name",
        },
      },
      { name: "Impacto" },
      {
        name: "Resultado",
        order: {
          active: false,
          type: "asc",
          key: "value",
        },
      },
      { name: "1-2" },
      { name: "3" },
      { name: "4-5" },
      { name: "" },
      {
        name: "Variación",
        order: {
          active: false,
          type: "asc",
          key: "name",
        },
      },
    ],
    sorter: false,
  }

  componentDidMount() {
    this.addColumn()
  }

  componentDidUpdate(nextProps, prevState) {
    if (!isEqual(this.props.showColumnImpact, nextProps.showColumnImpact)) {
      this.addColumn()
    }
  }

  setStateFrom = (values) => {
    this.setState(values)
  }

  renderBubble = (e) => {
    return (
      <div
        className="ResultByDimensionComponent-table-body-row-bubble"
        style={e.impact == 0 ? { gridTemplateColumns: "auto auto auto" } : {}}>
        {e.impact >= 0.5 ? (
          <Tooltip
            placement="right"
            overlayClassName="tooltipWhite"
            title="Alto impacto">
            <img src={imgMark} />
          </Tooltip>
        ) : (
          <div />
        )}

        <span
          style={
            e.impact == 0
              ? { marginLeft: 0, textAlign: "center", color: "#8d8a8d" }
              : {}
          }>
          {e.impact == 0 ? (
            <Tooltip title="El impacto no es significativo.">
              <span style={{ color: "#8D8A8D" }}>-</span>
            </Tooltip>
          ) : (
            e.impact
          )}
        </span>
        {e.impact != 0 ? <Bubbles left={e.impact} right={e.impact} /> : <div />}
      </div>
    )
  }

  renderRow = (e, i, isChild = false) => {
    if (e?.name === "Engagement") return

    const {
      openDimensions,
      bubble,
      showVariation,
      showCheckbox,
      selectedDimension,
      selectedDivision = {},
      showColumnImpact,
    } = this.props
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    const contentWarning = (
      <div className="content-warning-action">
        <p>
          Identificado como <b>oportunidad de mejora.</b>
        </p>
        <Button
          type="primary"
          onClick={() => {
            woopraTrack("Crear plan de acción")
            this.setState({ modalActionPlanCreate: true })
          }}>
          Crear plan de acción
        </Button>
      </div>
    )
    const getMeasureStatus = find(
      this.props.meditions,
      (medition) => medition.id_measure === selectedDivision.id_measure
    ) || { engagement: true }

    return (
      <Fragment key={`${i}-2`}>
        <div
          key={i}
          className={`ResultByDimensionComponent-table-body-row ${showColumnImpact &&
            "ResultByDimensionComponent-table-body-row-showColumnImpact"}  ${
            e.is_long
              ? "ResultByDimensionComponent-table-body-rowQuestion"
              : isChild
              ? "ResultByDimensionComponent-table-body-rowChild"
              : ""
          }${
            this.state.paintRowIndex === e.id_dimension && !e.question_name
              ? " pain-row-color"
              : ""
          }`}
          style={
            bubble
              ? showVariation
                ? {
                    gridTemplateColumns:
                      "140px 2fr 0.6fr 0.3fr 0.3fr 0.3fr 1fr minmax(108px, 0.4fr) 0.2fr",
                  }
                : {
                    gridTemplateColumns:
                      "140px 2fr 0.6fr 0.3fr 0.3fr 0.3fr 1fr 0.2fr",
                  }
              : showVariation
              ? {
                  gridTemplateColumns:
                    "2fr 0.66fr 0.3fr 0.3fr 0.3fr 1fr minmax(108px, 0.4fr) 0.2fr",
                }
              : {}
          }>
          {bubble && this.renderBubble(e)}

          <div
            className={`ResultByDimensionComponent-table-body-row-description ${
              !isChild ? " bold" : ""
            }`}
            style={{ paddingLeft: e.level * (showCheckbox ? 18 : 14) }}>
            {e.level !== 3 &&
              e.is_improvement_opportunity &&
              isActionPlans &&
              !this.props.hideIcons &&
              getMeasureStatus.id_measure_status === 5 && (
                <Popover
                  placement="top"
                  content={contentWarning}
                  onVisibleChange={(visible) => {
                    if (visible) {
                      this.setState({ dimensionSelected: e })
                    } else {
                      this.setState({ dimensionSelected: undefined })
                    }
                  }}>
                  <img
                    className="image-warning"
                    style={bubble ? { left: -20 } : {}}
                    src={imgWarning}
                    alt="warning"
                  />
                </Popover>
              )}

            {showCheckbox && !e.is_long ? (
              <Checkbox
                checked={selectedDimension.includes(e.id_dimension)}
                onChange={() => this.props.onSelectDimension(e.id_dimension)}>
                {e?.name}
              </Checkbox>
            ) : (
              <span
                style={{
                  padding: 0,
                  display: "inline",
                  color: "#4F4F4F",
                  // cursor: [1, 2].includes(e.level) && validRole({ role: [1, 2, 3, 4, 5] }) && this.props.selectedDivision ? 'pointer' : 'default'
                  cursor:
                    [1, 2].includes(e.level) &&
                    this.props.selectedDivision &&
                    getMeasureStatus.id_measure_status === 5
                      ? "pointer"
                      : "default",
                }}
                onClick={() => {
                  // if ([1, 2].includes(e.level) && validRole({ role: [1,2, 3, 4, 5] }) && this.props.selectedDivision) {
                  if (
                    [1, 2].includes(e.level) &&
                    this.props.selectedDivision &&
                    getMeasureStatus.id_measure_status === 5
                  ) {
                    this.setState({
                      drawerActionPlan: true,
                      dimensionSelected: e,
                    })
                  }
                }}
                onMouseEnter={() => {
                  if (e.level === 3) return
                  this.setState({ paintRowIndex: e.id_dimension })
                }}
                onMouseLeave={() => {
                  if (e.level === 3) return
                  this.setState({ paintRowIndex: undefined })
                }}>
                {e?.name}
              </span>
            )}
            {validRole({ role: [1, 2, 3, 4, 5] }) &&
              e.level === 1 &&
              !this.props.hideIcons &&
              e.action_plan &&
              e.comment &&
              getMeasureStatus.id_measure_status === 5 && (
                <div className="actions-ellipses-comment">
                  <div>
                    {!!e.action_plan.count && (
                      <Tooltip
                        placement="top"
                        title={`${e.action_plan.count} ${
                          e.action_plan.count === 1
                            ? "plan de acción nuevo"
                            : "planes de acción nuevos"
                        }`}>
                        <span
                          style={{
                            filter: `grayscale(${Number(
                              !e.action_plan.unread
                            )})`,
                          }}
                          onClick={async () => {
                            if (
                              [1, 2].includes(e.level) &&
                              this.props.selectedDivision
                            ) {
                              this.setState({
                                drawerActionPlan: true,
                                dimensionSelected: e,
                                drawerActionPlanOpenIn: "1",
                              })
                            }

                            await markReadActionPlan({
                              data: {
                                id_measure: e.id_measure,
                                id_division: e.id_division,
                                id_dimension: e.id_dimension,
                              },
                            })

                            if (this.props.getDimensions)
                              this.props.getDimensions(true)
                          }}>
                          {e.action_plan.count}
                          <img src={imgEllipses} alt="img-ellipses" />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                  <div>
                    {!!e.comment.count && (
                      <Tooltip
                        placement="top"
                        title={`${e.comment.count} ${
                          e.comment.count === 1
                            ? "nuevo comentario"
                            : "nuevos comentarios"
                        }`}>
                        <span
                          style={{
                            filter: `grayscale(${Number(!e.comment.unread)})`,
                          }}
                          onClick={async () => {
                            if (
                              [1, 2].includes(e.level) &&
                              this.props.selectedDivision
                            ) {
                              this.setState({
                                drawerActionPlan: true,
                                dimensionSelected: e,
                                drawerActionPlanOpenIn: "2",
                              })
                            }
                            await markReadComment({
                              data: {
                                id_measure: e.id_measure,
                                id_division: e.id_division,
                                id_dimension: e.id_dimension,
                              },
                            })

                            if (this.props.getDimensions)
                              this.props.getDimensions(true)
                          }}>
                          {e.comment.count}
                          <img src={imgCommentTable} alt="img-comment-table" />
                        </span>
                      </Tooltip>
                    )}
                  </div>
                </div>
              )}
          </div>
          {showColumnImpact && (
            <div className="ResultByDimensionComponent-table-body-row-description text-center">
              {!e.is_long && this.renderBubble(e)}
            </div>
          )}
          <div className="ResultByDimensionComponent-table-body-row-description">
            <span style={{ backgroundColor: e.color }}>{e.value_visible}</span>
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
            {e.value_low_visible}
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
            {e.value_middle_visible}
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description color-gray-low">
            {e.value_visible}
          </div>
          <div className="ResultByDimensionComponent-table-body-row-description">
            <ProgressBar
              values={{
                low: e.value_low_visible,
                top: e.value_visible,
                middle: e.value_middle_visible,
              }}
            />
          </div>
          {showVariation && (
            <div className="ResultByDimensionComponent-table-body-row-description color-gray-low text-center">
              {e.variation == 0
                ? e.variation === 0
                  ? "0%"
                  : "-"
                : e.variation > 0
                ? `${e.variation}%`
                : `${e.variation}%`.replace(/-(?=\d)/, "")}
              {e.variation != 0 && (
                <div
                  className={`resultByDimension-triangle ${
                    e.variation > 0
                      ? "resultByDimension-triangle--positive"
                      : ""
                  }`}
                />
              )}
            </div>
          )}
          <div className="ResultByDimensionComponent-table-body-row-description text-center">
            {e.childs && e.childs.length > 0 ? (
              openDimensions.includes(e.id_dimension) ? (
                <img
                  src={FlechaSVG}
                  onClick={() => this.props.clickDimension(e)}
                  style={{ cursor: "pointer", transform: "rotate(90deg)" }}
                />
              ) : (
                <img
                  src={FlechaSVG}
                  onClick={() => this.props.clickDimension(e)}
                  style={{ cursor: "pointer", transform: "rotate(-180deg)" }}
                />
              )
            ) : null}
          </div>
        </div>

        {e.childs &&
          openDimensions.includes(e.id_dimension) &&
          e.childs.map((c, i) => this.renderRow(c, i, true))}
      </Fragment>
    )
  }

  compareValues = (key, order = "asc") => {
    return (a, b) => {
      // eslint-disable-line
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0
      }

      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key]
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key]

      let comparison = 0
      if (varA > varB) {
        comparison = 1
      } else if (varA < varB) {
        comparison = -1
      }
      return order == "desc" ? comparison * -1 : comparison
    }
  }

  sortColumn = (key, type) => {
    const { columns } = this.state
    columns.map((e) => {
      if (e.order) e.order.active = false
    })
    columns[key].order.type = type
    columns[key].order.active = true
    let items = this.props.data
    items = items.sort(this.compareValues(columns[key].order.key, type))
    this.setState({
      columns,
      sorter: columns[key].order.type,
    })
  }

  addColumn = () => {
    const { showColumnImpact } = this.props
    const { columns } = this.state

    let setColumns = []
    if (!showColumnImpact) {
      setColumns = [...columns, { name: "", showIcon: true }]
    } else {
      setColumns = columns.filter((item) => !item.showIcon)
    }
    this.setState({ columns: setColumns })
  }

  renderIconQuestions = () => {
    const { measureColorRange } = this.props
    return <MeasurementColorRange measureColorRange={measureColorRange} />
  }

  setTitleColumn = (item) => {
    const { showColumnImpact, metricsTotalLabel } = this.props

    let response
    if (!showColumnImpact) {
      response = !item.showIcon ? item?.name : this.renderIconQuestions()
    } else {
      response = item?.name ? item?.name : this.renderIconQuestions()
    }

    if (response === "Resultado") {
      return (
        <Tooltip placement="top" title={metricsTotalLabel}>
          {truncate(metricsTotalLabel, {
            length: 16,
            separator: /,? +/,
          })}
        </Tooltip>
      )
    }

    return response
  }

  render() {
    const {
      data,
      divisions,
      isLoading,
      bubble,
      showVariation,
      hideHeaders,
      showColumnImpact,
      selectedDivision = {},
    } = this.props
    const { columns, sorter, dimensionSelected } = this.state
    const getMeasureStatus = find(
      this.props.meditions,
      (medition) => medition.id_measure === selectedDivision.id_measure
    ) || { engagement: true }

    const tooltip = (
      <Popover
        placement="leftTop"
        title="Impacto"
        content={
          <div
            style={{
              maxWidth: 400,
              textAlign: "justify",
              margin: "15px auto",
            }}>
            El análisis de <b>Impacto</b> identifica, a través de un modelo
            estadístico de correlación, cuáles son las dimensiones que tienen un
            mayor impacto en el <b>Engagement</b> de la organización. De esta
            manera, la organización podrá crear planes de acción direccionados a
            aquellas dimensiones que tienen una mayor probabilidad de afectar
            directamente el resultado de <b>Engagement</b>.<br />
            Para facilitar su rápida identificación, las dimensiones con un alto
            impacto se encuentran marcadas con un ícono (
            <img src={imgMark} height="13" />
            ).
          </div>
        }>
        <QuestionCircleFilled
          style={{
            color: "#D8D8D8",
            verticalAlign: "baseline",
            fontSize: "14px",
          }}
        />
      </Popover>
    )

    const contentVariation = (
      <div className="content-variation">
        <p>
          La <span>variación</span> hace referencia a la diferencia porcentual
          entre el resultado del indicador en la medición anterior versus la
          medición actual.
        </p>
        <div>
          <div className="content-variation__triangle content-variation__triangle--positive" />
          Variación positiva (incremento)
        </div>
        <div>
          <div className="content-variation__triangle" />
          Variación negativa (disminución)
        </div>
      </div>
    )

    return (
      <div className="ResultByDimensionComponent">
        <div className="ResultByDimensionComponent-table">
          <div className="ResultByDimensionComponent-table-body ResultByDimensionComponent-table-body-header">
            <div
              className={`ResultByDimensionComponent-table-body-row ${showColumnImpact &&
                "ResultByDimensionComponent-table-body-row-showColumnImpact"}`}
              style={
                bubble
                  ? showVariation
                    ? {
                        gridTemplateColumns:
                          "140px 2fr 0.66fr 0.3fr 0.3fr 0.3fr 1fr minmax(108px, 0.4fr) 0.2fr",
                      }
                    : {
                        gridTemplateColumns:
                          "140px 2fr 0.6fr 0.3fr 0.3fr 0.3fr 1fr 0.2fr",
                      }
                  : showVariation
                  ? {
                      gridTemplateColumns:
                        "2fr 0.66fr 0.3fr 0.3fr 0.3fr 1fr minmax(108px, 0.4fr) 0.2fr",
                    }
                  : {}
              }>
              {bubble && (
                <div className="ResultByDimensionComponent-table-body-row-title text-center">
                  Impacto {tooltip}{" "}
                </div>
              )}
              {columns.map((item, i) => {
                if (!showVariation && item?.name === "Variación") return
                if (!showColumnImpact && item?.name === "Impacto") return

                return (
                  <div
                    key={i}
                    className={`ResultByDimensionComponent-table-body-row-title ${
                      item?.name === "Variación" || item?.name === "Impacto"
                        ? "text-center"
                        : ""
                    }`}>
                    {!hideHeaders.includes(i) && this.setTitleColumn(item)}
                    {item?.name === "Variación" && (
                      <Popover
                        placement="bottomRight"
                        content={contentVariation}>
                        <img
                          src={questionIcon}
                          alt="question"
                          style={{ marginLeft: 4, cursor: "pointer" }}
                        />
                      </Popover>
                    )}
                    {hideHeaders.includes(i) || !item.order ? null : (
                      <div
                        className="reorderColumn"
                        onClick={() =>
                          this.sortColumn(i, sorter == "asc" ? "desc" : "asc")
                        }>
                        <CaretUpOutlined
                          className={`reorderColumn-up ${
                            item.order.active && item.order.type === "asc"
                              ? "reorderColumn-active"
                              : ""
                          }`}
                        />
                        <CaretDownOutlined
                          className={`reorderColumn-down ${
                            item.order.active && item.order.type === "desc"
                              ? "reorderColumn-active"
                              : ""
                          }`}
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
          {isLoading ? (
            <div className="ResultByDimensionComponent-table-body-loading">
              <Spin size="large" />
            </div>
          ) : (
            <div className="ResultByDimensionComponent-table-body">
              {data && data.map((e, i) => this.renderRow(e, i))}
              {!this.props.hideMessageLess25 &&
                showColumnImpact &&
                get(data, "[0].showImpact", false) &&
                getMeasureStatus.engagement && (
                  <div
                    className={`result-dimensions-less25 ${
                      data && data.length >= 12 ? "rotate" : ""
                    }`}>
                    <div>
                      <span>
                        Se requiere de un mínimo de 25 respuestas para poder
                        calcular el impacto.
                      </span>
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

ResultByDimensionV2.propTypes = {}
ResultByDimensionV2.defaultProps = {
  hideHeaders: [],
  onSelectDimension: () => {},
  selectedDimension: [],
  showColumnImpact: false, // mostrar columna impacto
}
export default ResultByDimensionV2
